export const isPshbUser = (customers) =>
  Boolean(
    customers?.pshb ||
    customers?.socialSecurity === "40080/000" ||
    customers?.socialSecurity?.includes?.("40080")
  );

export const normalizePshbCustomer = (customers) => {
  if (!customers || !isPshbUser(customers)) {
    return customers;
  }

  return {
    ...customers,
    socialSecurity: "40080/000",
    socialSecurityNumber: customers.credencial || customers.socialSecurityNumber,
  };
};
